import React from "react";

const JQuery_AJAX_Intro = () => {
  return (
    <div>
      <h1>JQuery_AJAX_Intro</h1>
      <p>Placeholder component for: "JQuery_AJAX_Intro"</p>
    </div>
  );
};

export default JQuery_AJAX_Intro;
